// Emitted at build time by the emit-version-json vite plugin. Also referenced by
// datadogRum, which must keep the poll out of RUM — see the comment there.
export const VERSION_JSON_URL = '/version.json'

// VITE_TAG is inlined at build time as `tags/v0.0.359 - 2026-07-30 11:22:33`
// (or `branches/<name> - ...` for feature-branch builds, empty locally).
export const parseTag = (raw: string): string =>
  raw.replace(/^(tags|branches)\//, '').split(' - ')[0]

export const CURRENT_VERSION = parseTag(import.meta.env.VITE_TAG || '')

// Only released tags are comparable — branch builds and local dev are not.
export const isTagVersion = (version: string): boolean =>
  /^v?\d+(\.\d+)*$/.test(version)

const segments = (version: string): number[] =>
  version.replace(/^v/, '').split('.').map(Number)

// 0 means "nothing to update to" — older, equal, or not comparable.
export const versionsBehind = (remote: string, local: string): number => {
  if (!isTagVersion(remote) || !isTagVersion(local)) {
    return 0
  }

  const [rMajor = 0, rMinor = 0, rPatch = 0] = segments(remote)
  const [lMajor = 0, lMinor = 0, lPatch = 0] = segments(local)

  // Every release bumps the patch, so within a major.minor line the patch delta
  // is the number of missed releases. A major/minor bump just counts as one.
  if (rMajor === lMajor && rMinor === lMinor) {
    return Math.max(rPatch - lPatch, 0)
  }

  return rMajor > lMajor || (rMajor === lMajor && rMinor > lMinor) ? 1 : 0
}

export const behindLabel = (count: number): string =>
  `${count} version${count === 1 ? '' : 's'} behind`
